import { RatingType } from '@/core/data/rating/rating.type';
import type { PlayerRatingsDto } from '@/core/data/user/user.interface';
import { RatingDisplayMode } from '@/core/data/user/user.type';
import PlayerHelper from '@/core/helpers/player.helper';
import type { GamChipType } from '@/views/composables/models/components/GamChip';

export default class ProfileHelper {
  static getProfileRatings(
    ratings?: PlayerRatingsDto[],
    ratingDisplayMode?: RatingDisplayMode,
  ): GamChipType[] | undefined {
    if (ratings?.length) {
      return ratings
        .filter((rating: PlayerRatingsDto) => rating.type !== RatingType.PUZZLE)
        .map((rating: PlayerRatingsDto) => {
          const isDots = ratingDisplayMode === RatingDisplayMode.DOTS && rating.type === RatingType.GAMBIT;
          if (isDots && rating.rating) {
            return {
              dotsRating: rating.rating,
              leftIcon: PlayerHelper.getPlayerRatingIcon(rating.type),
            };
          }
          return {
            label: rating.rating?.toString(),
            leftIcon: rating.type ? PlayerHelper.getPlayerRatingIcon(rating.type) : undefined,
          };
        })
        .filter((chip) => chip.label || chip.dotsRating);
    }
  }
  static getProfileAvailability(availability?: string | null): GamChipType[] | undefined {
    if (availability === null) {
      return [
        {
          label: 'profile.my.availability.status.not',
        },
      ];
    }
  }
}
